module.exports = __webpack_public_path__ + "static/media/change.0b7ca80b.svg";